import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import { Box, Card, CardContent, CardHeader, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialTypography from "../../../../components/MaterialTypography";

function OutstandingBalanceView() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;

  return (
    <DashboardLayout>
      <Card sx={{ minHeight: "90vh" }}>
        <CardContent>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Outstanding Balance View
            </MaterialTypography>
          </Stack>
          <div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <Card
                sx={{
                  maxWidth: 700,
                  width: "100%",
                  borderRadius: 3,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                }}
              >
                <CardHeader
                  title={
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Outstanding Balance
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  }
                />
                <CardContent>
                  <Grid container>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Customer Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Customer Name:</strong> {data?.customerName}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Customer Code:</strong> {data?.customerCode}
                        </MaterialTypography>
                      </Box>
                    </Grid>
                    {/* <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Role Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Role:</strong> {data?.role}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Rep Name:</strong> {data?.repName}{" "}
                          {data.productUom}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Rep Code:</strong> {data?.repCode}{" "}
                          {data.productUom}
                        </MaterialTypography>
                      </Box>
                    </Grid> */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Transaction Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Invoice Number:</strong> {data?.invoiceNumber}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Balance:</strong> {data?.balance}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Partial Paid Amount:</strong>{" "}
                          {data?.partialPaidAmount || "N/A"}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Remaining Amount:</strong>{" "}
                          {data?.remainingAmount || "N/A"}
                        </MaterialTypography>
                      </Box>
                    </Grid>
                    {/* <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Agent Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Agent Name:</strong> {data?.agentName}
                        </MaterialTypography>
                      </Box>
                    </Grid> */}
                  </Grid>
                </CardContent>
                <MaterialBox
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={() => navigate("/outstanding-balance")}
                  >
                    Back
                  </MaterialButton>
                </MaterialBox>
              </Card>
            </Box>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default OutstandingBalanceView;
